import React from 'react';
import { Stack, Text } from '@moda/om';
import { PageMeta } from '../../components/PageMeta';
import { useScrollHashReferenceToView } from '../../hooks/useScrollHashReferenceToView';

import './LegalBrandGuideLinesPage.scss';

export const LegalBrandGuideLinesPage = () => {
  useScrollHashReferenceToView();

  return (
    <>
      <PageMeta title="LegalBrandGuideLinesPage" />

      <div className="LegalBrandGuideLinesPage">
        <div className="LegalBrandGuideLinesPage__title">
          <Text treatment="h3">Moda Operandi Brand Legal Terms</Text>
        </div>
        <Stack space={4}>
          <Stack className="LegalBrandGuideLinesPage__section" space={4}>
            <Text treatment="bold1">
              The Moda Operandi Marks are any of Moda Operandi, Inc.’s or its affiliates’ names,
              logos, wordmarks, or other marks, including, but not limited to:
            </Text>
            <Text treatment="body1" family="serif">
              1. The Moda Operandi, M.O, Moda Domus, Moda Rewards, and Moda Private word marks
              <br />
              2. The Moda Operandi logos
              <br />
              3. The
              <div className="LegalBrandGuideLinesPage__image">
                <img src="/dist/public/modashapes.svg" alt="moda shapes" />
              </div>
              shapes
            </Text>
            <Text treatment="body1" family="serif">
              These Moda Operandi Trademark Guidelines (“Guidelines”) apply to your use of the Moda
              Operandi Marks.
            </Text>
          </Stack>
          <div className="LegalBrandGuideLinesPage__columns">
            <Stack className="LegalBrandGuideLinesPage__column" space={4}>
              <Text treatment="body2" family="serif">
                1. You may not use Moda Operandi Marks as your own or to refer to your own goods or
                services. You also may not incorporate Moda Operandi Marks, in whole or in part, in
                the name of your company, product, service, website, domain name, application, or
                website.
              </Text>
              <Text treatment="body2" family="serif">
                2. You may not alter the Moda Operandi Marks in any manner, including, but not
                limited to, changing the proportion, color, or shape of the Moda Operandi Marks, or
                adding or removing any elements from the Moda Operandi Marks. The Moda Operandi
                Marks must appear by themselves, with reasonable spacing between each side of the
                marks and other visual, graphic, or textual elements.
              </Text>
              <Text treatment="body2" family="serif">
                3. The Moda Operandi Marks should not be placed in any way that interferes with the
                readability or display of the entirety of the Moda Operandi Marks.
              </Text>
              <Text treatment="body2" family="serif">
                4. You may not use the Moda Operandi Marks in any manner that implies sponsorship or
                endorsement by Moda Operandi without an express written permission and license from
                an authorized representative of Moda Operandi. Unless specifically authorized by
                Moda
              </Text>
            </Stack>
            <Stack className="LegalBrandGuideLinesPage__column" space={4}>
              <Text treatment="body1" family="serif">
                Operandi in writing, you are not permitted to, or to allow others to, license or
                make, sell, or give away anything incorporating any Moda Operandi Marks.
              </Text>
              <Text treatment="body2" family="serif">
                5. You may not use the Moda Operandi Marks to defame or disparage Moda Operandi, its
                affiliates, or its products, services, customers, employees, or suppliers, or in a
                manner which, in Moda Operandi’s sole discretion, may diminish or tarnish Moda
                Operandi’s goodwill in the Moda Operandi Marks.
              </Text>
              <Text treatment="body2" family="serif">
                6. When creating a product, app, website, or other service that uses or interacts
                with Moda Operandi, you must use a unique name, logo, and design that cannot be
                confused with the Moda Operandi Marks. You should not apply for any trademarks or
                domains that include the Moda Operandi Marks or any confusingly similar variations.
              </Text>
              <Text treatment="body2" family="serif">
                7. You acknowledge that all rights to the Moda Operandi Marks are the exclusive
                property of Moda Operandi, and all goodwill generated through your use of the Moda
                Operandi Marks will inure to the sole benefit of Moda Operandi. You will not take
                any action that is in conflict with Moda Operandi’s rights in, to, or ownership of,
                the Moda Operandi Marks.
              </Text>
            </Stack>
          </div>
        </Stack>
      </div>
    </>
  );
};
